import { shadows } from "lib/theme";
import { fontVariants } from "theme/fontVariants";
import { fonts, space } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

const icon = {
  transition: "background 0.3s ease",
  p: `${space["-1"]} ${space["1"]}`,
  "&:hover": {
    background: colours.primary.medium
  }
};

export const linkStates = {
  textDecoration: "none",
  borderBottom: `1px solid ${colours.secondary.deep}`,
  "&:hover, &:focus": {
    background: colours.secondary.warm,
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: shadows.shadow1
  }
};

export const textLinkStates = {
  textDecoration: "underline",
  backgroundColor: "transparent",
  paddingLeft: "2px",
  paddingRight: "2px",
  marginLeft: "-2px",
  marginRight: "-2px",
  color: colours.primary.dark,
  "&:hover": {
    backgroundColor: colours.secondary.soft
  },
  "&:active, &:focus": {
    textDecoration: "underline",
    backgroundColor: "transparent"
  }
};

const breadcrumb = {
  ...fontVariants.acuminLight,
  marginRight: "30px",
  position: "relative",
  color: colours.primary.dark,
  fontWeight: "400",
  display: "inline-block",
  textTransform: "capitalize",
  ...linkStates,
  borderBottom: "none",
  "&::before": {
    position: "absolute",
    content: "'/'",
    right: "-20px",
    pointerEvents: "none",
    top: 0,
    color: colours.primary.dark,
    opacity: "0.2"
  },
  "&:last-child": {
    marginRight: "0"
  },
  "&.active": {
    position: "inherit",
    color: colours.primary.dark
  },
  "&:focus": {
    boxShadow: "0",
    background: `${colours.secondary.soft}`
  }
};

export const breadcrumbActive = {
  ...breadcrumb,
  color: colours.primary.dark,
  "&::before": {}
};

const subNav = {
  ...fontVariants.capsM1,
  p: 2,
  color: colours.secondary.light,
  display: "block"
};

export const Link = {
  baseStyle: {
    fontFamily: fonts.demi,
    fontWeight: "medium",
    "&:hover": {
      textDecoration: "none"
    }
  },
  variants: {
    ...fontVariants,
    inlineShareIcon: {
      ...icon
    },
    footerShareIcon: {
      ...icon,
      _first: {
        paddingLeft: 0
      },
      "& svg": {
        fill: "#FFF"
      },
      "&:hover": {
        background: "",
        "& svg": {
          fill: colours.accent.soft
        }
      }
    },
    breadcrumb,
    breadcrumbActive,
    breadcrumbSmall: {
      ...breadcrumb,
      ...fontVariants.bookM2
    },
    breadcrumbLarge: {
      ...breadcrumb,
      ...fontVariants.bookM1
    },
    breadcrumbLarger: {
      ...breadcrumb,
      ...fontVariants.book0
    },
    textLink: {
      ...fontVariants.book1,
      ...textLinkStates
    },
    textLinkDisclaimer: {
      ...fontVariants.bookM1,
      ...textLinkStates,
      color: "inherit"
    },
    textLinkBlog: {
      ...textLinkStates,
      fontFamily: fonts.acuminLight
    },
    textLinkLight: {
      ...fontVariants.book1,
      ...textLinkStates,
      color: colours.secondary.light,
      "&:active, &:focus": {
        textDecoration: "underline",
        backgroundColor: "transparent",
        color: colours.secondary.light
      }
    },
    textLinkNoUnderline: {
      ...fontVariants.book1,
      ...textLinkStates,
      textDecoration: "none"
    },
    textLinkLightNoUnderline: {
      ...fontVariants.book1,
      ...textLinkStates,
      color: colours.secondary.light,
      textDecoration: "none",
      "&:active, &:focus": {
        textDecoration: "none",
        backgroundColor: "transparent",
        color: colours.secondary.light
      }
    },
    mainNav: {
      ...fontVariants.book1,
      textTransform: "uppercase",
      py: 1,
      letterSpacing: "0.2em",
      textAling: "center",
      pb: -2,
      mx: 1,
      "&:hover": {
        boxShadow: shadows.shadow1,
        zIndex: "3"
      }
    },
    subNav,
    desktopNavItem: {
      ...fontVariants.acuminLight,
      "&:hover p": {
        color: colours.primary.dark
      },
      "& p": {
        fontSize: 1,
        lineHeight: "1.875rem",
        color: colours.primary.dark
      }
    },
    ctaLink: {
      ...fontVariants.acuminRegular,
      backgroundColor: colours.accent.medium,
      outline: "none",
      border: "none",
      textTransform: "none",
      "&:hover,&:focus": {
        backgroundColor: colours.accent.medium
      }
    }
  }
};
